export default class ConnectionUtil {
  constructor(){
    this._connectionObject = navigator.connection;
  }
  connection(){
    return this._connectionObject;
  }

  getConnectionEffectiveType(){
    if(!this.connection()) return null;
    if(!this.connection().effectiveType) return null;

    return this.connection().effectiveType;
  }
}
